import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter, HashRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import axios from "axios";
import store, { persistor } from "./redux/store";
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/global.css';

axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
  const token = store.getState().auth?.token;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Fade out the first-load loader (public/index.html) once the app has rendered
// and the web fonts are ready (never waiting more than 1.5s for them), but keep
// it on screen for at least BOOT_MIN_MS from page start so it can be seen.
const BOOT_MIN_MS = 2500;
const hideBootLoader = () => {
  const boot = document.getElementById("fz-boot");
  if (!boot) return;
  boot.classList.add("fz-loader--hide");
  setTimeout(() => boot.remove(), 400);
};
Promise.all([
  Promise.race([
    document.fonts?.ready ?? Promise.resolve(),
    new Promise((resolve) => setTimeout(resolve, 1500)),
  ]),
  new Promise((resolve) => setTimeout(resolve, Math.max(0, BOOT_MIN_MS - performance.now()))),
]).then(() => requestAnimationFrame(hideBootLoader));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HashRouter>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </HashRouter>
);
